var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg20Deals = function Svg20Deals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.41 11.812h3.266l1.09 1.312h4.355l1.089-1.312h3.266M5.043 17.434c-.902 0-1.634-.839-1.634-1.874V4.317c0-1.035.732-1.874 1.634-1.874h9.8c.902 0 1.633.839 1.633 1.874V15.56c0 1.035-.731 1.874-1.633 1.874z"
  })));
};
export default Svg20Deals;